import { $authHost } from 'app/configs/axiosConfig';
import {
  AdminFilters,
  FilteredProcessors,
  IProcessor,
  IProcessorGeneratedUrls,
  IProcessorItemData,
  IProcessorUpdateRequest,
  ProcessorInvite,
  ProcessorStats,
} from '../types';

export const getProcessorsAll = (ids?: string) => {
  return $authHost.get<IProcessor>('/processor', {
    params: {
      ids,
      take: 100,
    },
  });
};

export const getCurrentProcessor = () => {
  return $authHost.get<IProcessorItemData>(`/processor/me`);
};

export const updateProcessorById = (processor: IProcessorUpdateRequest, processorId: number) => {
  return $authHost.patch<IProcessorUpdateRequest>(`/processor/${processorId}`, processor);
};

export const generateImgUrls = (extension: string) => {
  return $authHost.post<IProcessorGeneratedUrls>('/processor/generate-profile-image-upload-url', {
    extension,
  });
};

export const getFilteredProcessors = (filters: AdminFilters) => {
  if (filters.where) {
    const where = filters.where as any;
    if (where.OR && Array.isArray(where.OR)) {
      where.OR = where.OR.map(processWhereCondition);
    }
    if (where.AND && Array.isArray(where.AND)) {
      where.AND = where.AND.map(processWhereCondition);
    }
  }
  return $authHost.post<FilteredProcessors>(`/processor/filter`, filters);
};

const processWhereCondition = (condition: any): any => {
  if (!condition || typeof condition !== 'object') return condition;

  const processedCondition = { ...condition };

  Object.keys(processedCondition).forEach((key) => {
    const value = processedCondition[key];

    if (value && typeof value === 'object' && !Array.isArray(value)) {
      if (
        typeof value.contains === 'string' ||
        typeof value.equals === 'string' ||
        typeof value.startsWith === 'string' ||
        typeof value.endsWith === 'string'
      ) {
        value.mode = 'insensitive';

        if (value.contains) value.contains = value.contains.trim().replace(/\s+/g, ' ');
        if (value.equals) value.equals = value.equals.trim().replace(/\s+/g, ' ');
        if (value.startsWith) value.startsWith = value.startsWith.trim().replace(/\s+/g, ' ');
        if (value.endsWith) value.endsWith = value.endsWith.trim().replace(/\s+/g, ' ');
      } else {
        processedCondition[key] = processWhereCondition(value);
      }
    }
  });

  return processedCondition;
};

export const getProcessorStats = (id: number) => {
  return $authHost.get<ProcessorStats>(`/processor/stats`, { params: { id } });
};

export const inviteProcessor = (body: ProcessorInvite) => {
  return $authHost.post(`/processor/invite`, body);
};
